export default __webpack_public_path__ + "static/media/Niramit-LightItalic.979d2d51.ttf";